import Auth from "./Auth/Reducer";
import App from './App/Reducer';
import Sidebar from "./Sidebar/Reducer";

// eslint-disable-next-line
export default {
    Auth,
    App,
    Sidebar
}